<!-- The public watch page stands alone, even for someone who is signed in: its own header, no
     platform bar, breadcrumbs or download tracker. -->
@if (authService.isAuthenticated() && !publicPage()) {
  <app-navbar></app-navbar>
  <app-breadcrumbs></app-breadcrumbs>
}
<main [class]="authService.isAuthenticated() && !publicPage() ? 'bg-gray-50' : ''">
  <!-- WhatsApp invite (CC 18/10/2026): on the page they land on; only when WhatsApp is live and they are not on it. -->
  @if (authService.isAuthenticated() && !publicPage()) {
    <app-whatsapp-prompt-card></app-whatsapp-prompt-card>
  }
  <router-outlet></router-outlet>
</main>
@if (!publicPage()) {
  <app-download-pill></app-download-pill>
}
<!-- What's new (CC 18/10/2026): the card about a new feature, beside its button. -->
@if (authService.isAuthenticated() && !publicPage()) {
  <app-whats-new-card></app-whats-new-card>
}
